// extracted by mini-css-extract-plugin
module.exports = {"root":"_2uKFu","bg":"_3q3n6"};